import { AppError } from './app-error.model';

export class PreconditionError extends AppError {

}